import {auth, getUser} from '../lib/http/auth';

const UPDATE_USER_SESSION = 'scratch-gui/user-session/UPDATE_USER_SESSION';
const CLEAR_USER_SESSION = 'scratch-gui/user-session/CLEAR_USER_SESSION';

const getCachedUser = () => {
    try {
        return getUser();
    } catch (e) {
        return null;
    }
};

const getUserSessionSnapshot = user => {
    const isAuthenticated = auth.isAuthenticated();
    return {
        isAuthenticated,
        user: isAuthenticated ? (typeof user === 'undefined' ? getCachedUser() : user) : null
    };
};

const initialState = getUserSessionSnapshot();

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case UPDATE_USER_SESSION:
        return Object.assign({}, state, action.session);
    case CLEAR_USER_SESSION:
        return {
            isAuthenticated: false,
            user: null
        };
    default:
        return state;
    }
};

const updateUserSession = user => ({
    type: UPDATE_USER_SESSION,
    session: getUserSessionSnapshot(user)
});

const clearUserSession = () => ({
    type: CLEAR_USER_SESSION
});

export {
    reducer as default,
    initialState as userSessionInitialState,
    clearUserSession,
    updateUserSession
};
